/* 定制素材库@米德 统一配置 */
const config = {};

if (MIDE_BUILD === 'PRODUCTION') {
    /* 生产环境配置 */
    config.scratchAssetRoot = 'https://md-scratch.oss-cn-zhangjiakou.aliyuncs.com';
} else {
    /* 开发环境配置 测试环境配置 */
    config.scratchAssetRoot = 'https://md-scratch.oss-cn-zhangjiakou.aliyuncs.com';
}

if (location.hostname.startsWith('a')) {
    /* admin端后端域名配置 */
    config.scratchApiRoot = location.origin.replace('.', '-service.')
        .replace('a', 'admin');
} else if (location.hostname.startsWith('192')) {
    config.scratchApiRoot = '';
    config.scratchAssetRoot = '';
} else if (location.hostname.startsWith('bisai')) {
    config.scratchApiRoot = location.origin.replace('.', '-service.')
        .replace('bisai', 'jingsai');
} else {
    /* 其他端后端域名配置 */
    config.scratchApiRoot = location.origin.replace('.', '-service.');
}

export default config;
